var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "view--presale-list"
  }, [!_vm.loadingPresales ? _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', [_c('b-card', [_c('b-card-title', [_vm._v("Resultaten")]), _vm.presales.length === 0 ? _c('div', [_c('p', [_vm._v("Geen resultaten gevonden.")])]) : _c('b-table-simple', [_c('b-thead', [_c('b-tr', _vm._l(_vm.visibleColumns, function (displayName, index) {
    return _c('b-th', {
      key: index
    }, [_vm._v(" " + _vm._s(displayName) + " ")]);
  }), 1)], 1), _c('b-tbody', _vm._l(_vm.sortedPresales, function (presale, index) {
    return _c('b-tr', {
      key: index,
      on: {
        "click": function ($event) {
          return _vm.onRowClick(presale);
        }
      }
    }, [_vm._l(presale, function (value, key, index) {
      return [!_vm.isHiddenColumn(key) ? _c('b-td', {
        key: index
      }, [_vm.isDateColumn(key) ? [_vm._v(" " + _vm._s(_vm.parseDate(value)) + " ")] : [_vm._v(" " + _vm._s(value) + " ")]], 2) : _vm._e()];
    })], 2);
  }), 1)], 1)], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }